import React from "react";
import CareersRedesign from "../redesign/CareersRedesign";

const Careers = () => {
  return <CareersRedesign />;
};

export default Careers;
